// extracted by mini-css-extract-plugin
module.exports = {"root":"card-module--root--3N2-o","dataAnchor":"card-module--dataAnchor--3p_cy","job":"card-module--job--2-466","logo":"card-module--logo--2rho6","name":"card-module--name--3Hz77"};